const Sliders = {
	init: function(){
		$('.wine-awards-container').slick({
	      rows: 0,
	      dots: false,
	      autoplay: true,
	      autoplaySpeed: 3000,
	      easing: 'ease-out',
	      pauseOnHover: false,
	      speed: 600,
	      prevArrow: '.arrow-full-prev-2',
	      nextArrow: '.arrow-full-next-2',
	      mobileFirst: true,
	      responsive: [
	        {
	          breakpoint: 768, 
	          settings: "unslick"
	      }],
	    });

	    $('.in-single-wine').slick({
	      rows: 0,
	      dots: false,
	      autoplay: true,
	      autoplaySpeed: 3000,
	      easing: 'ease-out',
	      pauseOnHover: false,
	      speed: 600,
	      prevArrow: '.arrow-full-prev-3',
	      nextArrow: '.arrow-full-next-3',
	      mobileFirst: true,
	      responsive: [
	        {
	          breakpoint: 768, 
	          settings: "unslick"
	      }],
	    });

	    $('.wc-testimonials').on('init', function() {
	    	$(this).find('button').addClass('bg-color-f');
	    })

	    $('.wc-testimonials').slick({
	      rows: 0,
	      dots: true,
	      infinite: true,
	      speed: 600,
	      slidesToShow: 1,
	      pauseOnHover: false,
	      prevArrow: '.arrow-full-prev',
	      nextArrow: '.arrow-full-next',
	      autoplay: true,
	      autoplaySpeed: 3000,
	      // customPaging : function(slider, i) {
	      //   return `<a><img src="${templateDirectory}/public/images/icons/dot.png" /><img src="${templateDirectory}/public/images/icons/dot.png" /></a>`;
	      // },
	    });

	    $('.vu-events-grid').slick({
	      rows: 0,
	      dots: false,
	      // autoplay: true,
	      // autoplaySpeed: 5000,
	      easing: 'ease-out',
	      pauseOnHover: false,
	      speed: 600,
	      prevArrow: '.arrow-full-prev-2',
	      nextArrow: '.arrow-full-next-2',
	      mobileFirst: true,
	      responsive: [
	        {
	          breakpoint: 768, 
	          settings: "unslick"
	      }],
	    });

	    $('.home-stories-grid').slick({
	      rows: 0,
	      dots: false,
	      // autoplay: true,
	      // autoplaySpeed: 5000,
	      easing: 'ease-out',
	      pauseOnHover: false,
	      speed: 600,
	      prevArrow: '.arrow-full-prev-2',
	      nextArrow: '.arrow-full-next-2',
	      mobileFirst: true,
	      responsive: [
	        {
	          breakpoint: 768, 
	          settings: "unslick"
	      }],
	    });

	    $('.vu-slider-container').slick({
	      rows: 0,
	      dots: true,
	      infinite: true,
	      speed: 600,
	      slidesToShow: 1,
	      pauseOnHover: false,
	      prevArrow: '.arrow-full-prev-1',
	      nextArrow: '.arrow-full-next-1',
	      autoplay: false,
	      // autoplaySpeed: 3000,
	      // customPaging : function(slider, i) {
	      //   return `<a><img src="${templateDirectory}/public/images/icons/dot.png" /><img src="${templateDirectory}/public/images/icons/dot.png" /></a>`;
	      // },
	    });

	    if(window.innerWidth < 769) {
	      /* the viewport is less than 768 pixels wide */
	      $('.slider').slick();
	    } 
	}
}

export default Sliders;